import { Component, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from '../../services/api-service.service';
import { LoaderService } from '../../services/loader.service';
// Adjust the import according to your actual service location

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss',
})
export class MyProfileComponent implements AfterViewInit {
  userData: any = {};
  isEditMode: boolean = false;
  countries: any;

  constructor(
    private api: ApiServiceService,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private Loader: LoaderService
  ) {}

  ngAfterViewInit() {
    this.getUserByToken();
    this.getStateByCountry(this.countries);
  }

  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  getUserByToken() {
    this.Loader.showLoader();
    this.api.getUserByToken().subscribe((res: any) => {
      this.Loader.hideLoader();
      if (res.data == null) {
        this.router.navigate(['Signin', 0]);
        this.toastr.error('Please Login First To Access Profile', '', {
          toastClass: 'ngx-toastr toast-custom',
        });
      } else {
        this.userData = res.data;
      }
    });
  }

  onSubmit() {
    // Logic to update the data goes here
    const para = {
      name: this.userData.name,
      email: this.userData.email,
      mobile: this.userData.mobile,
      // address : this.userData.addressdelivery_address,
      // city : this.userData.address.delivery_city,
      // state : this.userData.state,
      // country : this.userData.country,
      // pincode : this.userData.pincode
    };
    this.api.updateProfile(para).subscribe(
      (response) => {
        this.toastr.success('Profile updated successfully');
        this.isEditMode = false;
      },
      (error) => {
        this.toastr.error('Error updating profile');
      }
    );
  }

  countryselected(event: any) {
    const country = event.target.value;
    this.getStateByCountry(country);
  }

  getStateByCountry(country: any) {
    const para = {
      country: country,
    };
    this.api.getStateByCountry(para).subscribe((data: any) => {
      this.countries = data.data[0];
    });
  }
}
